import React, { Component } from "react";
import { Button, Image, Modal } from "semantic-ui-react";
import AnalysisDetailsField from "features/FolderManager/components/Prescription/AnalysisDetailsField";

const styles = {
	headerAnalysisCircle: {
		padding: "1em",
		marginBottom: "2em",
		textAlign: "center",
	},
	circleAnalysis: {
		height: 50,
		width: 50,
		borderRadius: "50%",
		border: "1px solid #5f9be0",
		textAlign: "center",
		lineHeight: "48px",
		fontWeight: 600,
		color: "#5f9be0",
		cursor: "pointer",
		fontSize: "0.7em",
		boxShadow: "rgba(0, 0, 0, 0.14) 0px -5px 17px -5px inset, rgb(148, 148, 148) 0px 9px 13px -10px",
		margin: "auto",
	},
	circleTitle: {
		fontSize: "0.6em",
		height: 20,
		lineHeight: "1em",
		display: "flex",
		alignItems: "center",
	},
	tubesContainer: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap",
	},
	tube: {
		maxWidth: 90,
		margin: "1em",
	},
	header: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		flexWrap: "wrap",
	},
	headerLeft: {
		width: "30%",
	},
	headerRight: {
		width: "70%",
	},
	containerField: {
		fontSize: "0.9em",
		width: "100%",
		marginBottom: 5,
	},
	label: {
		fontWeight: 600,
	},
	textField50: {
		width: "50%",
	},
	textField40: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		textAlign: "center",
	},
	textField35: {
		width: "35%",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
	},
};

class NotesForTubeDetailedModal extends Component {
	render() {
		const { open, tube, close } = this.props;
		return (
			<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				<Modal.Content>
					{tube &&
						tube.analyses &&
						tube.analyses.length > 0 &&
						tube.analyses.map(
							(analysis, index) =>
								analysis !== null && (
									<div key={`analysis-${index}`} style={{ width: "100%", display: "flex", margin: "1em 3em", paddingRight: "3em" }}>
										<div>
											<b style={{ color: "#4092e8", fontSize: "1.3em" }}>
												{analysis.properties.code} - {analysis.properties.label}
											</b>
											<br />
											{analysis.properties.pretreatment_note && (
												<AnalysisDetailsField label="Commentaires pré-traitement" field={analysis.properties.pretreatment_note} />
											)}
											{analysis.properties.taking_note && (
												<AnalysisDetailsField label="Note pour prélèvement" field={analysis.properties.taking_note} />
											)}
										</div>
									</div>
								)
						)}
				</Modal.Content>
				<Modal.Actions>
					<Button
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							close();
						}}
					>
						Fermer
					</Button>
				</Modal.Actions>
			</Modal>
		);
	}
}

export default NotesForTubeDetailedModal;
